import config from "../config.json";
import { apiClient, getAccessToken } from "./apiClient";

const SearchCloseReason = async (queryParams) => {
    const token = await getAccessToken();
    queryParams = queryParams || {};
    const params = new URLSearchParams();
    let paramCount = 0;

    Object.entries(queryParams).forEach(([key, value]) => {
        if (value != null && value !== undefined) {
            params.append(key, value);
            paramCount++;
        }
    });

    let url = `${config.API_URL}/close-reasons/search`;

    if (paramCount > 0) {
        url += `?${params.toString()}`;
    }

    let headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
    };

    try {
        return await apiClient.get(url, {
            headers,
            timeout: config.API_CONNECTION_TIMEOUT,
        });
    } catch (error) {
        throw error;
    }
};

const CloseReasonService = {
    SearchCloseReason,
};

export default CloseReasonService;